/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputCheckoutServiceRequest } from '../models';
// @ts-ignore
import type { InputCompleteServiceRequestById } from '../models';
// @ts-ignore
import type { InputWebhookCheckoutMollie } from '../models';
// @ts-ignore
import type { Order } from '../models';
// @ts-ignore
import type { ResponseCheckoutServiceRequest } from '../models';
// @ts-ignore
import type { ServiceRequest } from '../models';
/**
 * ServiceRequestApi - axios parameter creator
 * @export
 */
export const ServiceRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Checkout service request
         * @param {InputCheckoutServiceRequest} [inputCheckoutServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutServiceRequest: async (inputCheckoutServiceRequest?: InputCheckoutServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceRequest/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCheckoutServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary complete a single service request
         * @param {number} id 
         * @param {InputCompleteServiceRequestById} [inputCompleteServiceRequestById] complete a single service request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeServiceRequestById: async (id: number, inputCompleteServiceRequestById?: InputCompleteServiceRequestById, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeServiceRequestById', 'id', id)
            const localVarPath = `/serviceRequest/userCompleted/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCompleteServiceRequestById, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get citizen service request | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCitizenServiceRequest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceRequest/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary  get main service requests | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {number} [status] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainServiceRequests: async (status?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceRequest/lightApi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get mollie payment by id
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMolliePaymentById: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getMolliePaymentById', 'orderId', orderId)
            const localVarPath = `/serviceRequest/checkout/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get raw service request by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawServiceRequestById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRawServiceRequestById', 'id', id)
            const localVarPath = `/serviceRequest/rawRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get service request by id | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRequestById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getServiceRequestById', 'id', id)
            const localVarPath = `/serviceRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary giveway to citizen a single service request
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givewayToCitizenServiceRequestById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('givewayToCitizenServiceRequestById', 'id', id)
            const localVarPath = `/serviceRequest/cafMemberCompleted/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Webhook checkout mollie
         * @param {InputWebhookCheckoutMollie} [inputWebhookCheckoutMollie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookCheckoutMollie: async (inputWebhookCheckoutMollie?: InputWebhookCheckoutMollie, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceRequest/checkout/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputWebhookCheckoutMollie, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceRequestApi - functional programming interface
 * @export
 */
export const ServiceRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Checkout service request
         * @param {InputCheckoutServiceRequest} [inputCheckoutServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutServiceRequest(inputCheckoutServiceRequest?: InputCheckoutServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCheckoutServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutServiceRequest(inputCheckoutServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.checkoutServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary complete a single service request
         * @param {number} id 
         * @param {InputCompleteServiceRequestById} [inputCompleteServiceRequestById] complete a single service request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeServiceRequestById(id: number, inputCompleteServiceRequestById?: InputCompleteServiceRequestById, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeServiceRequestById(id, inputCompleteServiceRequestById, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.completeServiceRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get citizen service request | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCitizenServiceRequest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCitizenServiceRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.getCitizenServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary  get main service requests | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {number} [status] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMainServiceRequests(status?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMainServiceRequests(status, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.getMainServiceRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get mollie payment by id
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMolliePaymentById(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMolliePaymentById(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.getMolliePaymentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get raw service request by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawServiceRequestById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawServiceRequestById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.getRawServiceRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get service request by id | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceRequestById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceRequestById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.getServiceRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary giveway to citizen a single service request
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async givewayToCitizenServiceRequestById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.givewayToCitizenServiceRequestById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.givewayToCitizenServiceRequestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Webhook checkout mollie
         * @param {InputWebhookCheckoutMollie} [inputWebhookCheckoutMollie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookCheckoutMollie(inputWebhookCheckoutMollie?: InputWebhookCheckoutMollie, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookCheckoutMollie(inputWebhookCheckoutMollie, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestApi.webhookCheckoutMollie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceRequestApi - factory interface
 * @export
 */
export const ServiceRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary Checkout service request
         * @param {InputCheckoutServiceRequest} [inputCheckoutServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutServiceRequest(inputCheckoutServiceRequest?: InputCheckoutServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCheckoutServiceRequest> {
            return localVarFp.checkoutServiceRequest(inputCheckoutServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary complete a single service request
         * @param {number} id 
         * @param {InputCompleteServiceRequestById} [inputCompleteServiceRequestById] complete a single service request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeServiceRequestById(id: number, inputCompleteServiceRequestById?: InputCompleteServiceRequestById, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.completeServiceRequestById(id, inputCompleteServiceRequestById, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get citizen service request | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCitizenServiceRequest(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequest>> {
            return localVarFp.getCitizenServiceRequest(options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary  get main service requests | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {number} [status] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainServiceRequests(status?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.getMainServiceRequests(status, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get mollie payment by id
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMolliePaymentById(orderId: number, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.getMolliePaymentById(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get raw service request by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.getRawServiceRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get service request by id | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.getServiceRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary giveway to citizen a single service request
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givewayToCitizenServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest> {
            return localVarFp.givewayToCitizenServiceRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Webhook checkout mollie
         * @param {InputWebhookCheckoutMollie} [inputWebhookCheckoutMollie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookCheckoutMollie(inputWebhookCheckoutMollie?: InputWebhookCheckoutMollie, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.webhookCheckoutMollie(inputWebhookCheckoutMollie, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceRequestApi - interface
 * @export
 * @interface ServiceRequestApi
 */
export interface ServiceRequestApiInterface {
    /**
     * 
     * @summary Checkout service request
     * @param {InputCheckoutServiceRequest} [inputCheckoutServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    checkoutServiceRequest(inputCheckoutServiceRequest?: InputCheckoutServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCheckoutServiceRequest>;

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary complete a single service request
     * @param {number} id 
     * @param {InputCompleteServiceRequestById} [inputCompleteServiceRequestById] complete a single service request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    completeServiceRequestById(id: number, inputCompleteServiceRequestById?: InputCompleteServiceRequestById, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Get citizen service request | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    getCitizenServiceRequest(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequest>>;

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary  get main service requests | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {number} [status] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    getMainServiceRequests(status?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     * 
     * @summary Get mollie payment by id
     * @param {number} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    getMolliePaymentById(orderId: number, options?: RawAxiosRequestConfig): AxiosPromise<Order>;

    /**
     * 
     * @summary Get raw service request by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    getRawServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get service request by id | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    getServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary giveway to citizen a single service request
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    givewayToCitizenServiceRequestById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequest>;

    /**
     * 
     * @summary Webhook checkout mollie
     * @param {InputWebhookCheckoutMollie} [inputWebhookCheckoutMollie] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApiInterface
     */
    webhookCheckoutMollie(inputWebhookCheckoutMollie?: InputWebhookCheckoutMollie, options?: RawAxiosRequestConfig): AxiosPromise<any>;

}

/**
 * ServiceRequestApi - object-oriented interface
 * @export
 * @class ServiceRequestApi
 * @extends {BaseAPI}
 */
export class ServiceRequestApi extends BaseAPI implements ServiceRequestApiInterface {
    /**
     * 
     * @summary Checkout service request
     * @param {InputCheckoutServiceRequest} [inputCheckoutServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public checkoutServiceRequest(inputCheckoutServiceRequest?: InputCheckoutServiceRequest, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).checkoutServiceRequest(inputCheckoutServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary complete a single service request
     * @param {number} id 
     * @param {InputCompleteServiceRequestById} [inputCompleteServiceRequestById] complete a single service request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public completeServiceRequestById(id: number, inputCompleteServiceRequestById?: InputCompleteServiceRequestById, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).completeServiceRequestById(id, inputCompleteServiceRequestById, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Get citizen service request | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public getCitizenServiceRequest(options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).getCitizenServiceRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary  get main service requests | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {number} [status] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public getMainServiceRequests(status?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).getMainServiceRequests(status, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get mollie payment by id
     * @param {number} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public getMolliePaymentById(orderId: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).getMolliePaymentById(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get raw service request by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public getRawServiceRequestById(id: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).getRawServiceRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get service request by id | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public getServiceRequestById(id: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).getServiceRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary giveway to citizen a single service request
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public givewayToCitizenServiceRequestById(id: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).givewayToCitizenServiceRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Webhook checkout mollie
     * @param {InputWebhookCheckoutMollie} [inputWebhookCheckoutMollie] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestApi
     */
    public webhookCheckoutMollie(inputWebhookCheckoutMollie?: InputWebhookCheckoutMollie, options?: RawAxiosRequestConfig) {
        return ServiceRequestApiFp(this.configuration).webhookCheckoutMollie(inputWebhookCheckoutMollie, options).then((request) => request(this.axios, this.basePath));
    }
}

